import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'countryCurrency',
  pure: true
})
export class CountryCurrencyPipe extends CurrencyPipe implements PipeTransform {

  private cache: string;
  // 5 undefined to not fail the check in transform
  private oldValues = [undefined, undefined, undefined, undefined, undefined, undefined];

  constructor(private translateService: TranslateService) {
    super(translateService.currentLang);
  }

  // Copied and extended call signature from Angular source:
  // angular/packages/common/src/pipes/number_pipe.ts
  transform(
    value: number|string,
    currencyCode?: string,
    display?: string|boolean,
    digitsInfo?: string,
    country?: string,
    locale?: string
  ): string|null;
  transform(
    value: null|undefined,
    currencyCode?: string,
    display?: string|boolean,
    digitsInfo?: string,
    country?: string,
    locale?: string
  ): null;
  transform(
    value: number|string|null|undefined,
    currencyCode?: string,
    display?: string|boolean,
    digitsInfo?: string,
    country?: string,
    locale?: string
  ): string|null;
  transform(
    value: number|string|null|undefined,
    currencyCode: string,
    display: string|boolean,
    digitsInfo?: string,
    country?: string,
    locale?: string
  ): string|null {
    if (!locale) {
      locale = this.translateService.currentLang;
    }
    if (country !== null) {
      locale = country.toUpperCase() === 'IT' ? 'it' : 'en';
    }
    const currentParams = [value, currencyCode, display, digitsInfo, country, locale];
    if (!this.cache || currentParams.some((el, idx) => el !== this.oldValues[idx])) {
      this.oldValues = currentParams;
      this.cache = super.transform(value, currencyCode, display, digitsInfo, locale);
    }
    return this.cache;
  }
}
